module.exports = __webpack_public_path__ + "static/media/company.0a398380.png";